import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import { TOAST_TYPE, FUNDING_SETUP_LIMIT } from "../../Constants/constant";
import { ahActions, generalActions } from "../actions";
import {
  getCreatedCosInvoicesRequest,
  getClaimedCaseNotesListRequest,
} from "../actions/ah.actions";
import ACTIONS from "../constants";
import api from "../services/ah.services";
import { getInvoiceActionSuccessToastTitle } from "Utils/invoiceActionSuccessToastTitle";
import { normalizeFolderListApiPayload } from "Utils/utils";

function* updateCaseNotesSaga(state) {
  try {
    yield put(ahActions.updateCaseNotesAction.pending);
    // alert("api");
    const response = yield call(api.updateCaseNotesApi, state.payload);
    if (response) {
      yield put(ahActions.updateCaseNotesAction.success(response.data));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Case Note Updated Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.updateCaseNotesAction.error(error));
  }
}

function* getCosCaseNoteDetailSaga(state) {
  try {
    yield put(ahActions.getCaseNoteDetailsAction.pending);
    const response = yield call(api.getCaseNotesDetails, state.payload);
    if (response) {
      yield put(ahActions.getCaseNoteDetailsAction.success(response.data));
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.getCaseNoteDetailsAction.error(error));
  }
  // getCseNotesDetails
}

function* getFolderListForHRMSaga(state) {
  try {
    yield put(ahActions.getFolderListForHRMAction.pending);
    const response = yield call(api.getFolderLIstForHrm, state.payload);
    if (response) {
      yield put(
        ahActions.getFolderListForHRMAction.success(
          normalizeFolderListApiPayload(response)
        )
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.getFolderListForHRMAction.error(error));
  }
}

function* createNewFolderSaga(state) {
  try {
    yield put(ahActions.createFolderAction.pending);
    const response = yield call(api.createNewFolderApi, state.payload);
    if (response) {
      yield put(ahActions.createFolderAction.success(response));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Folder Created Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.createFolderAction.error(error));
  }
}

function* updateFolder(state) {
  try {
    yield put(ahActions.updateFolder.pending);
    const response = yield call(api.updateFolderApi, state.payload);
    if (response) {
      yield put(ahActions.updateFolder.success(response));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Folder Updated Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.updateFolder.error(error));
  }
}

function* removeFolder(state) {
  try {
    yield put(ahActions.removeFolder.pending);
    // Extract callback from payload if it exists
    const { callback, ...apiPayload } = state.payload || {};
    const response = yield call(api.removeFolderApi, apiPayload);
    if (response) {
      yield put(ahActions.removeFolder.success(response));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Folder Deleted Successfully!",
        })
      );
      // Call the callback if provided (for Promise-based deletion flows)
      if (callback) {
        callback(response, null);
      }
    } else {
      // If response is falsy, still call callback with error
      if (callback) {
        callback(null, new Error("Failed to delete folder"));
      }
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.removeFolder.error(error));
    // Call the callback with error (for Promise-based deletion flows)
    const { callback } = state.payload || {};
    if (callback) {
      callback(null, error);
    }
  }
}

function* removeFile(state) {
  try {
    yield put(ahActions.removeFile.pending);
    // Extract callback from payload if it exists
    const { callback, ...apiPayload } = state.payload || {};
    const response = yield call(api.removeFileApi, apiPayload);
    if (response) {
      yield put(
          ahActions.removeFile.success({ response, removedId: apiPayload })
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "File Deleted Successfully!",
        })
      );
      // Call the callback if provided (for Promise-based deletion flows)
      if (callback) {
        callback(response, null);
      }
    } else {
      // If response is falsy, still call callback with error
      if (callback) {
        callback(null, new Error("Failed to delete file"));
      }
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.removeFile.error(error));
    // Call the callback with error (for Promise-based deletion flows)
    const { callback } = state.payload || {};
    if (callback) {
      callback(null, error);
    }
  }
}

function* updatePriority(state) {
  try {
    yield put(ahActions.updatePriority.pending);
    const response = yield call(api.updatePriorityApi, state.payload);
    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Task Priority Updated Successfully!",
        })
      );
      yield put(ahActions.updatePriority.success(response.cos_priority));
    }
  } catch (error) {
    yield put(ahActions.updatePriority.error(error));
  }
}

function* updateContact(state) {
  try {
    yield put(ahActions.updateContact.pending);
    const response = yield call(api.updateContactApi, state.payload);

    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Note Contact Type Updated Successfully!",
        })
      );
      yield put(ahActions.updateContact.success(response.contact_type));
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.updateContact.error(error));
  }
}

function* updateCategory(state) {
  try {
    yield put(ahActions.updateCategory.pending);
    const response = yield call(api.updateCategoryApi, state.payload);

    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Task Category Updated Successfully!",
        })
      );
      yield put(
          ahActions.updateCategory.success(response.client_task_category)
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something went wrong!",
      })
    );
    yield put(ahActions.updateCategory.error(error));
  }
}

function* getDashboardData(state) {
  try {
    yield put(ahActions.getDashboardData.pending);
    const response = yield call(api.getDashboardDataApi, state.payload);

    if (response) {
      yield put(ahActions.getDashboardData.success(response));
    }
  } catch (error) {
    yield put(ahActions.getDashboardData.error(error));
  }
}

function* getFundingSetupParticipantForCos(state) {
  try {
    yield put(ahActions.fundingSetupParticipantFosCos.pending);
    const response = yield call(
      api.getFundingSetupParticipantFosCos,
      state.payload
    );

    if (response) {
      yield put(ahActions.fundingSetupParticipantFosCos.success(response));
    }
  } catch (error) {
    yield put(
        ahActions.fundingSetupParticipantFosCos.error(error.message || error)
    );
  }
}

function* getCosReportingFundingTableData(state) {
  try {
    yield put(ahActions.getCosReportingFundingTableData.pending);
    const response = yield call(
      api.getCosReportingFundingTableDataApi,
      state.payload
    );

    if (response) {
      if (state.payload.type === "funding") {
        yield put(ahActions.getCosReportingFundingTableData.success(response));
      } else {
        yield put(
            ahActions.getCosReportingForCaseNotesFundingTableData.success(
            response
          )
        );
      }
    }
  } catch (error) {
    yield put(ahActions.getCosReportingFundingTableData.error(error));
  }
}

function* getPeriorityList(state) {
  try {
    yield put(ahActions.getPeriorityList.pending);
    const response = yield call(api.getPeriorityListApi, state.payload);

    if (response) {
      yield put(ahActions.getPeriorityList.success(response));
    }
  } catch (error) {
    yield put(ahActions.getPeriorityList.error(error));
  }
}

function* getContactList(state) {
  try {
    yield put(ahActions.getContactList.pending);
    const response = yield call(api.cosContactSettingFetch, state.payload);

    if (response) {
      yield put(ahActions.getContactList.success(response));
    }
  } catch (error) {
    yield put(ahActions.getContactList.error(error));
  }
}

function* getCatogeryList(state) {
  try {
    yield put(ahActions.getCatogeryList.pending);
    const response = yield call(api.cosCategorySettingFetch, state.payload);

    if (response) {
      yield put(ahActions.getCatogeryList.success(response));
    }
  } catch (error) {
    yield put(ahActions.getCatogeryList.error(error));
  }
}

function* createNewContact(state) {
  try {
    yield put(ahActions.createNewContact.pending);
    const response = yield call(api.createNewContactApi, state.payload);

    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Note Contact Type Added Successfully!",
        })
      );
      yield put(ahActions.createNewContact.success(response));
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something went wrong!",
      })
    );
    yield put(ahActions.createNewContact.error(error));
  }
}

function* createNewCategory(state) {
  try {
    yield put(ahActions.createNewCategory.pending);
    const response = yield call(api.createNewCategoryApi, state.payload);

    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Task Category Added Successfully!",
        })
      );
      yield put(ahActions.createNewCategory.success(response));
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something went wrong!",
      })
    );
    yield put(ahActions.createNewCategory.error(error));
  }
}

function* createNewPeriority(state) {
  try {
    yield put(ahActions.createNewPeriority.pending);
    const response = yield call(api.createNewPeriorityApi, state.payload);
    if (response) {
      yield put(ahActions.createNewPeriority.success(response));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Task Priority Added Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something went wrong!",
      })
    );
    yield put(ahActions.createNewPeriority.error(error));
  }
}

function* changeNDISClaimInvoiceActions(state) {
  try {
    yield put(ahActions.changeNDISClaimInvoiceActions.pending);
    const response = yield call(
      api.changeActionsClaimInvoiceApi,
      state.payload
    );

    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: getInvoiceActionSuccessToastTitle(state.payload, response),
        })
      );
      yield put(ahActions.changeNDISClaimInvoiceActions.success(response));
      yield put(getCreatedCosInvoicesRequest());
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(ahActions.changeNDISClaimInvoiceActions.error(error));
  }
}

function* changeNDISClaimActions(state) {
  try {
    yield put(ahActions.changeNDISClaimActions.pending);
    const response = yield call(api.changeNDISClaimActionsApi, state.payload);
    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: getInvoiceActionSuccessToastTitle(state.payload),
        })
      );
      yield put(ahActions.changeNDISClaimActions.success(response));
      // Refresh the created NDIS claims list so list-page bulk actions pick up
      // the latest status (mirrors changeNDISClaimInvoiceActions saga behavior).
      yield put(getClaimedCaseNotesListRequest());
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(ahActions.changeNDISClaimActions.error(error));
  }
}

function* getCreatedCosInvoicesRviews(state) {
  try {
    yield put(ahActions.getCreatedCosInvoicesRviews.pending);
    const response = yield call(
      api.getCreatedCosInvoicesReviewsApi,
      state.payload
    );

    if (response) {
      yield put(ahActions.getCreatedCosInvoicesRviews.success(response));
    }
  } catch (error) {
    yield put(ahActions.getCreatedCosInvoicesRviews.error(error));
  }
}

function* getCreatedCosInvoices(state) {
  try {
    yield put(ahActions.getCreatedCosInvoices.pending);
    const response = yield call(api.getCreatedCosInvoicesApi, state.payload);

    if (response) {
      yield put(
          ahActions.getCreatedCosInvoices.success(response.created_cos_invoice)
      );
    }
  } catch (error) {
    yield put(ahActions.getCreatedCosInvoices.error(error));
  }
}

function* createCosInvoice(state) {
  try {
    yield put(ahActions.createCosInvoice.pending);
    const response = yield call(api.createCosInvoicesApi, state.payload);
    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Invoice Created Successfully!",
        })
      );

      yield put(ahActions.createCosInvoice.success(response.data.cos_invoice));
      state.payload.navigate("/ah/invoice");
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ?? "Something Went Wrong!",
      })
    );
    yield put(ahActions.createCosInvoice.error(error));
  }
}

function* getCoseInvoices(state) {
  try {
    yield put(ahActions.getCoseInvoices.pending);
    if (state.payload.report) {
      const response = yield call(api.getCosInvoicesReportApi, state.payload);
      yield window.open(response.report.download_url, "_blank");
      yield put(ahActions.getCoseInvoices.success(response));
    } else {
      const response = yield call(api.getCosInvoicesApi, state.payload);
      if (response) {
        yield put(ahActions.getCoseInvoices.success(response.cos_invoices));
      }
    }
  } catch (error) {
    yield put(ahActions.getCoseInvoices.error(error));
  }
}

function* getCaseNotesReview(state) {
  try {
    yield put(ahActions.getCaseNotesReview.pending);
    const response = yield call(api.getCaseNotesReviewApi, state.payload);
    if (response) {
      yield put(ahActions.getCaseNotesReview.success(response));
    }
  } catch (error) {
    yield put(ahActions.getCaseNotesReview.error(error));
  }
}

function* getClaimedCaseNotesList(state) {
  try {
    yield put(ahActions.getClaimedCaseNotesList.pending);
    const response = yield call(api.getClaimedCaseNotesListApi, state.payload);
    if (response) {
      yield put(
          ahActions.getClaimedCaseNotesList.success(
          response.created_cos_ndis_claims
        )
      );
    }
  } catch (error) {
    yield put(ahActions.getClaimedCaseNotesList.error(error));
  }
}
/////////
function* getNdisClaimMode() {
  try {
    yield put(ahActions.getNdisClaimModeAction.pending);
    const body = yield call(api.getNdisClaimModeApi);
    const mode = body?.mode ?? body?.data?.mode;
    const normalized =
      mode === "new" || mode === "old" ? mode : "old";
    yield put(ahActions.getNdisClaimModeAction.success(normalized));
  } catch (error) {
    yield put(ahActions.getNdisClaimModeAction.error(error));
  }
}

function* updateNdisClaimMode(state) {
  try {
    yield put(ahActions.updateNdisClaimModeAction.pending);
    const body = yield call(api.updateNdisClaimModeApi, state.payload);
    const mode = body?.mode ?? body?.data?.mode ?? state.payload?.mode;
    if (mode === "new" || mode === "old") {
      yield put(ahActions.updateNdisClaimModeAction.success(mode));
    } else {
      throw new Error("Invalid NDIS claim mode response");
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ?? "Failed to save NDIS claim mode preference",
      })
    );
    yield put(ahActions.updateNdisClaimModeAction.error(error));
  }
}

function* addCaseNotesToClaimList(state) {
  try {
    yield put(ahActions.addCaseNotesToClaimList.pending);
    const response = yield call(api.addToClaimApi, state.payload);
    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Claimed Successfully!",
        })
      );
      const d = response?.data ?? response;
      const downloadUrl = d?.download_url;
      if (downloadUrl) {
        yield window.open(downloadUrl, "_blank");
      }
      const claims =
        Array.isArray(d?.cos_ndis_claims) && d.cos_ndis_claims.length > 0
          ? d.cos_ndis_claims
          : d?.cos_ndis_claim
            ? [d.cos_ndis_claim]
            : [];
      yield put(ahActions.addCaseNotesToClaimList.success(claims));
      state.payload.navigate("/ah/ndis-claims");
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ?? "Something went wrong!",
      })
    );
    yield put(ahActions.addCaseNotesToClaimList.error(error));
  }
}

function* getCaseNotesListForClaim(state) {
  try {
    yield put(ahActions.getCaseNotesListForClaim.pending);
    if (state.payload.report) {
      const response = yield call(
        api.getCaseNotesForClaimListReportApi,
        state.payload
      );
      yield put(ahActions.getCaseNotesListForClaim.success(response));
      yield window.open(response.report.download_url, "_blank");
    } else {
      const response = yield call(
        api.getCaseNotesForClaimListApi,
        state.payload
      );
      yield put(ahActions.getCaseNotesListForClaim.success(response));
      if (response) {
        yield put(
            ahActions.getCaseNotesListForClaim.success(response.cos_ndis_claims)
        );
      }
    }
  } catch (error) {
    yield put(ahActions.getCaseNotesListForClaim.error(error));
  }
}

function* getCaseNotesHistoryList(state) {
  try {
    yield put(ahActions.getCaseNotesHistoryList.pending);
    const response = yield call(api.getCaseNotesHistoryListApi, state.payload);

    if (response) {
      yield put(
          ahActions.getCaseNotesHistoryList.success(response.case_notes_history)
      );
    }
  } catch (error) {
    yield put(ahActions.getCaseNotesHistoryList.error(error));
  }
}

function* getCaseNotesClients(state) {
  try {
    yield put(ahActions.getCaseNotesClients.pending);
    const response = yield call(api.getCaseNotesClients, state.payload);
    if (response) {
      yield put(ahActions.getCaseNotesClients.success(response.clients));
    }
  } catch (error) {
    yield put(ahActions.getCaseNotesClients.error(error));
  }
}

function* getSingleSupportTrack(state) {
  try {
    yield put(ahActions.getSingleSupportTrack.pending);
    const response = yield call(
      api.getSingleSupportTrackListApi,
      state.payload
    );

    if (response) {
      yield put(ahActions.getSingleSupportTrack.success(response));
    }
  } catch (error) {
    yield put(ahActions.getSingleSupportTrack.error(error));
  }
}

function* getSupportTrackList(state) {
  try {
    yield put(ahActions.getSupportTrackList.pending);
    const response = yield call(api.getSupportTrackListApi, state.payload);

    if (response) {
      yield put(ahActions.getSupportTrackList.success(response.case_notes));
    }
  } catch (error) {
    yield put(ahActions.getSupportTrackList.error(error));
  }
}

function* getReportData(state) {

  try {
    yield put(ahActions.getReportData.pending);
    const response = yield call(api.reportingCaseNotesHistory, state.payload);

    if (response) {
      if (state.payload.file_type === "pdf") {
        yield window.open(response.report_data.download_url, "_blank");
        yield put(ahActions.getReportData.success(response));
      } else {
        yield window.open(response.report_data.download_url, "_blank");
        yield put(ahActions.getReportData.success(response.report_data));
      }
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );

    yield put(ahActions.getReportData.error(error));
  }
}

function* deleteClientTasksListRequest(state) {
  try {
    yield put(ahActions.deleteClientTask.pending);
    const response = yield call(api.clientTaskDelete, state.payload);
    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Client Task deleted Successfully!",
        })
      );
      yield put(ahActions.deleteClientTask.success(response));
    }
  } catch (error) {
    yield put(ahActions.deleteClientTask.error(error));
  }
}

function* updateClientTasksListRequest(state) {
  try {
    yield put(ahActions.updateClientTask.pending);
    const response = yield call(api.updateClientTask, state.payload);
    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Client Task Updated Successfully!",
        })
      );
      yield put(ahActions.updateClientTask.success(response));
    }
  } catch (error) {
    yield put(ahActions.updateClientTask.error(error));
  }
}

function* getClientTasksListRequest(state) {
  try {
    yield put(ahActions.getClientTaskList.pending);
    const response = yield call(api.getClientTaskList, state.payload);
    if (response) {
      yield put(ahActions.getClientTaskList.success(response));
    }
  } catch (error) {
    yield put(ahActions.getClientTaskList.error(error));
  }
}
function* clientTaskCreate(state) {
  try {
    yield put(ahActions.createClientTask.pending);
    const response = yield call(api.createClientTask, state.payload);
    if (response) {
      yield put(ahActions.createClientTask.success(response));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Client Task Created Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(ahActions.createClientTask.error(error.message || error));
  }
}

function* caseNotesCreate(state) {
  try {
    yield put(ahActions.caseNotesCreate.pending);
    const response = yield call(api.createCaseNotes, state.payload.formData);
    if (response) {
      yield put(ahActions.caseNotesCreate.success(response));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Case Notes Created Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(ahActions.caseNotesCreate.error(error.message || error));
  }
}

function* getCaseNotesRequest(state) {
  try {
    yield put(ahActions.getCaseNotes.pending);

    const response = yield call(api.getCosCaseNote, state.payload);
    if (response.cos_case_notes.data) {
      yield put(ahActions.getCaseNotes.success(response.cos_case_notes));
    }
  } catch (error) {
    yield put(ahActions.getCaseNotes.error(error));
  }
}

function* getCosParticipantProfile(state) {
  try {
    yield put(ahActions.getCOSParticipantsProfile.pending);
    const response = yield call(api.getCosParticipantProfile, state.payload);

    if (response.participant) {
      yield put(
        ahActions.getCOSParticipantsProfile.success(response.participant)
      );
    }
  } catch (error) {
    yield put(ahActions.getCOSParticipantsProfile.error(error));
  }
}

function* getCatalogVersions(state) {
  try {
    yield put(ahActions.catalogVersions.pending);
    const response = yield call(api.getCatalogVersions);

    if (response) {
      if (
        state.isServiceCall &&
        response.success &&
        response.success.length > 0
      ) {
        const res = yield call(api.getAllCatalogServices, {
          page: 1,
          per_page: 100,
          version_id: response.success[response.success.length - 1]?.id,
        });
        if (res.data) {
          yield put(ahActions.getAllCatalogServices.success(res.data));
        }
      }

      yield put(ahActions.catalogVersions.success(response.success));
    }
  } catch (error) {
    yield put(ahActions.catalogVersions.error(error));
  }
}

function* getAllCatalogServices(state) {
  try {
    yield put(ahActions.getAllCatalogServices.pending);
    const response = yield call(api.getAllCatalogServices, state.payload);
    if (response.data) {
      yield put(ahActions.getAllCatalogServices.success(response.data));
    }
  } catch (error) {
    yield put(ahActions.getAllCatalogServices.error(error));
  }
}

function* checkFundingManagementImpact(state) {
  try {
    const response = yield call(
      api.checkFundingManagementUpdateImpact,
      state.payload
    );
    const data = response?.data !== undefined ? response.data : response;
    if (data) {
      yield put(ahActions.checkFundingManagementImpactSuccess(data));
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Something went wrong!",
      })
    );
  }
}

function* storeAndUpdateFundSetup(state) {
  try {
    yield put(ahActions.storeAndUpdateFundingSetup.pending);
    const response = yield call(
      state.isUpdate ? api.updateFundingSetup : api.storeFundingSetup,
      state.payload
    );
    if (response) {
      yield put(
        ahActions.storeAndUpdateFundingSetup.success({
          funding: response.funding,
          isUpdate: state.isUpdate,
        })
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: state.isUpdate
            ? "Funding Updated Successfully!"
            : "Funding Created Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ? error.message : "Something went wrong!",
      })
    );
    yield put(
      ahActions.storeAndUpdateFundingSetup.error(error.message || error)
    );
  }
}

function* getFundingSetupParticipant(state) {
  try {
    yield put(ahActions.fundingSetupParticipant.pending);
    const response = yield call(api.getFundingSetupParticipant, state.payload);

    if (response) {
      yield put(ahActions.fundingSetupParticipant.success(response));
    }
  } catch (error) {
    yield put(ahActions.fundingSetupParticipant.error(error.message || error));
  }
}

function* deleteFundingSetupSaga(action) {
  try {
    yield put(ahActions.deleteFundingSetup.pending);
    const response = yield call(api.deleteFundingSetup, {
      id: action.payload.id,
    });
    if (response) {
      yield put(ahActions.deleteFundingSetup.success());
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Funding removed successfully.",
        })
      );
      yield put(
        ahActions.getFundingSetupRequest({
          page: action.payload.page || 1,
          per_page: action.payload.per_page || FUNDING_SETUP_LIMIT,
          pt_id: action.payload.pt_id,
        })
      );
    }
  } catch (error) {
    yield put(ahActions.deleteFundingSetup.error(error));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.message ?? "Unable to delete funding.",
      })
    );
  }
}

function* getAllCatalogServicesSubCategory(state) {
  try {
    yield put(ahActions.getAllCatalogServicesSubCategory.pending);
    const response = yield call(api.getCatalogServicesSubCategoryApi);

    if (response) {
      yield put(
        ahActions.getAllCatalogServicesSubCategory.success(response.states)
      );
    }
  } catch (error) {
    yield put(ahActions.getAllCatalogServicesSubCategory.error(error));
  }
}

function* getSelectedFundingSetup(state) {
  try {
    yield put(ahActions.selectedFundingSetup.pending);
    const response = yield call(api.getSelectedFundingSetup, state.payload);
    if (response) {
      yield put(ahActions.selectedFundingSetup.success(response));
    }
  } catch (error) {
    yield put(ahActions.selectedFundingSetup.error(error.message || error));
  }
}

function* getPlanCatagories(state) {
  try {
    yield put(ahActions.planCatagories.pending);
    const response = yield call(api.getPlanCatagories, state.payload);
    if (response.service_cats) {
      yield put(ahActions.planCatagories.success(response.service_cats));
    }
  } catch (error) {
    yield put(ahActions.planCatagories.error(error.message || error));
  }
}

function* storePlanBudget(state) {
  try {
    yield put(ahActions.planBudgetCreated.pending);
    const response = yield call(
      state.payload.isUpdate ? api.updatePlanBudget : api.storePlanBudget,
      state.payload.data
    );
    if (response.data) {
      yield put(
        ahActions.planBudgetCreated.success({
          ...response.data,
          isUpdate: state.payload.isUpdate,
        })
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: `Plan Budget ${
            state.payload.isUpdate ? "Updated" : "Created"
          } Successfully!`,
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(ahActions.planBudgetCreated.error(error.message || error));
  }
}

function* planBudgetList(state) {
  try {
    yield put(ahActions.planBudgetList.pending);
    const response = yield call(api.planBudgetList, state.payload);
    if (response.data) {
      yield put(ahActions.planBudgetList.success(response.data.plan_budgets));
    }
  } catch (error) {
    yield put(ahActions.planBudgetList.error(error.message || error));
  }
}

function* serviceCategoryRemove(state) {
  try {
    yield put(ahActions.serviceCategoryRemove.pending);
    const response = yield call(api.serviceCategoryRemove, state.payload);
    if (response) {
      yield put(
        ahActions.serviceCategoryRemove.success({
          sp_category_budget_id: state.payload.id,
          plan_budget: response.plan_budget,
        })
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Service Category Successfully Deleted!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message || "Something went wrong!",
      })
    );
    yield put(ahActions.serviceCategoryRemove.error(error.message || error));
  }
}

function* planBudgetCatAndSubCat(state) {
  try {
    yield put(ahActions.planBudgetCatAndSubCat.pending);
    const response = yield call(api.planBudgetCatAndSubCat, state.payload);
    if (response.data) {
      yield put(ahActions.planBudgetCatAndSubCat.success(response.data));
    }
  } catch (error) {
    yield put(ahActions.planBudgetCatAndSubCat.error(error.message || error));
  }
}

function* storeServiceCategoryPlanBudget(state) {
  try {
    yield put(ahActions.serviceCategoryPlanBudgetStored.pending);
    const response = yield call(
      state.payload.isUpdate
        ? api.updateSeriveCategoryPlanBudget
        : api.storeSeriveCategoryPlanBudget,
      state.payload.data
    );
    if (response) {
      yield put(
        ahActions.serviceCategoryPlanBudgetStored.success({
          response,
          isUpdate: state.payload.isUpdate,
        })
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: `Service Provider Category Budget ${
            state.payload.isUpdate ? "Updated" : "Created"
          } Successfully!`,
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(
      ahActions.serviceCategoryPlanBudgetStored.error(error.message || error)
    );
  }
}

function* fetchServiceCategoryPlanBudget(state) {
  try {
    yield put(ahActions.serviceCategoryPlanBudgetFetched.pending);
    const response = yield call(
      api.fetchSeriveCategoryPlanBudget,
      state.payload
    );
    if (response) {
      yield put(ahActions.serviceCategoryPlanBudgetFetched.success(response));
    }
  } catch (error) {
    yield put(
      ahActions.serviceCategoryPlanBudgetFetched.error(error.message || error)
    );
  }
}

function* getExternalSpRequest(state) {
  try {
    yield put(ahActions.getExternalSPListFetched.pending);
    const response = yield call(api.getExternalSPListsCall, state.payload);
    if (response) {
      yield put(ahActions.getExternalSPListFetched.success(response));
    }
  } catch (error) {
    yield put(
      ahActions.getExternalSPListFetched.error(error.message || error)
    );
  }
}

function* externalSpCreate(state) {
  try {
    yield put(ahActions.createExternalSP.pending);
    const response = yield call(api.postServiceProvider, state.payload);
    if (response) {
      yield put(ahActions.createExternalSP.success(response));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "External SP created successfully",
        })
      );
    }
  } catch (error) {
    yield put(ahActions.createExternalSP.error(error ?? error.message));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title:
          error && error?.message ? error.message : "Something went Wrong!",
      })
    );
  }
}

function* fundingNotesList(state) {
  try {
    yield put(ahActions.fundingNotesList.pending);
    const response = yield call(api.fundingNotesListCall, state.payload);
    if (response) {
      yield put(ahActions.fundingNotesList.success(response.funding_notes));
    }
  } catch (error) {
    yield put(ahActions.fundingNotesList.error(error.message || error));
  }
}

function* storeFundingNotes(state) {
  try {
    yield put(ahActions.fundingNotesCreated.pending);
    const response = yield call(
      state.payload.isUpdate ? api.updateFundingNotes : api.storeFundingNotes,
      state.payload.formData
    );
    if (response) {
      yield put(
        ahActions.fundingNotesCreated.success({
          ...response,
          isUpdate: state.payload.isUpdate,
        })
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: `Funding Notes ${
            state.payload.isUpdate ? "Updated" : "Created"
          } Successfully!`,
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(ahActions.fundingNotesCreated.error(error.message || error));
  }
}

// function* fundingNotesRemove(state) {
//   try {
//     yield put(ahActions.fundingNotesRemove.pending);
//     const response = yield call(api.fundingNotesRemove, state.payload);
//     if (response) {
//       yield put(
//         ahActions.fundingNotesRemove.success({
//           fundingNotesId: state.payload.fundingNotesId,
//           funding: response.funding_notes,
//         })
//       );
//       yield put(
//         generalActions.showToast({
//           type: TOAST_TYPE.SUCCESS,
//           title: "Funding Notes Successfully Deleted!",
//         })
//       );
//     }
//   } catch (error) {
//     yield put(ahActions.fundingNotesRemove.error(error.message || error));
//   }
// }

function* serviceSupportCreate(state) {
  try {
    yield put(ahActions.serviceSupportBudgetCreated.pending);
    const response = yield call(
      state.payload.isUpdate
        ? api.updateServiceSupport
        : api.storeServiceSupport,
      state.payload.data
    );
    if (response) {
      const serviceSupportBudget =
        response.service_support_budget.service_support_budget;
      Object.assign(serviceSupportBudget, {
        plan_budget: response.service_support_budget.plan_budget,
        funding: response.service_support_budget.funding,
        sp_category_budget: response.service_support_budget.sp_category_budget,
        price_catalog: response.service_support_budget.price_catalog,
        external_sp: response.service_support_budget.external_sp,
      });
      yield put(
        ahActions.serviceSupportBudgetCreated.success({
          serviceSupportBudget: serviceSupportBudget,
          service_support_budget:
            response.service_support_budget.service_support_budget,
          isUpdate: state.payload.isUpdate,
        })
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: state.payload.isUpdate
            ? "Service Support Budget Successfully Updated!"
            : "Service Support Budget Successfully Created!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ? error.message : "Something went wrong!",
      })
    );
    yield put(
      ahActions.serviceSupportBudgetCreated.error(error.message || error)
    );
  }
}

function* serviceSupportFetch(state) {
  try {
    yield put(ahActions.serviceSupportBudgetFetched.pending);
    const response = yield call(api.fetchServiceSupport, state.payload);
    if (response.data) {
      yield put(ahActions.serviceSupportBudgetFetched.success(response.data));
    }
  } catch (error) {
    yield put(
      ahActions.serviceSupportBudgetFetched.error(error.message || error)
    );
  }
}

function* fetchServiceSupportsForDeliveredService(state) {
  try {
    yield put(ahActions.serviceSupportsForDeliveredServiceFetched.pending);
    const response = yield call(
      api.fetchServiceSupportsForDeliveredServices,
      state.payload
    );
    if (response) {
      if (state.payload.cos_case_notes === true) {
        yield put(
          ahActions.serviceSupportsForDeliveredServiceCaseNotesFetched(
            response
          )
        );
      } else {
        yield put(
          ahActions.serviceSupportsForDeliveredServiceFetched.success(
            response.service_support_items
          )
        );
      }
    }
  } catch (error) {
    // yield put(
    //   generalActions.showToast({
    //     type: TOAST_TYPE.ERROR,
    //     title: error.message ? error.message : "No Plan Budget Found!",
    //   })
    // );
    yield put(
      ahActions.serviceSupportsForDeliveredServiceFetched.error(
        error.message || error
      )
    );
  }
}
function* CosParticipantList(state) {
  try {
    yield put(ahActions.cosParticipant.pending);
    const response = yield call(api.cosParticipantListCall, state.payload);
    if (response) {
      yield put(ahActions.cosParticipant.success(response.data));
    }
  } catch (error) {
    yield put(ahActions.cosParticipant.error(error.message || error));
  }
}

function* supportCoordinator() {
  try {
    yield put(ahActions.supportCoordinators.pending);
    const response = yield call(api.supportCoordinatorCall);
    if (response) {
      yield put(
        ahActions.supportCoordinators.success(response.support_coordinate)
      );
    }
  } catch (error) {
    yield put(ahActions.supportCoordinators.error(error.message || error));
  }
}

function* deliveredServiceStore(state) {
  try {
    yield put(ahActions.deliveredServiceCreated.pending);
    const response = yield call(
      state.payload.isUpdate
        ? api.deliveredServiceStore
        : api.deliveredServiceStore,
      state.payload.data
    );
    if (response) {
      yield put(ahActions.deliveredServiceCreated.success(response.data));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Delivered Service Created Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ? error.message : "Something went wrong!",
      })
    );
    yield put(ahActions.deliveredServiceCreated.error(error.message || error));
  }
}

function* manualDeliveredServiceStore(state) {
  try {
    yield put(ahActions.manualDeliveredServiceCreated.pending);
    const response = yield call(api.manualDeliveredServiceStore, state.payload);
    if (response) {
      if (response.data) {
        const planBudget = {
          ...response.data.plan_budget,
          service_sub_category: response.data.service_sub_category,
        };
        const deliveredService = {
          ...response.data.delivered_service,
          service_category: response.data.service_category,
        };
        Object.assign(response.data, {
          plan_budget: { ...planBudget },
          delivered_service: { ...deliveredService },
        });
      }
      yield put(
        ahActions.manualDeliveredServiceCreated.success(response.data)
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Manual Delivered Service Created Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ? error.message : "Something went wrong!",
      })
    );
    yield put(
      ahActions.manualDeliveredServiceCreated.error(error.message || error)
    );
  }
}

function* deliveredServiceFetch(state) {
  try {
    yield put(ahActions.deliveredServiceFetched.pending);
    const response = yield call(api.deliveredServiceFetch, state.payload);
    if (response) {
      yield put(
        ahActions.deliveredServiceFetched.success(response.delivered_service)
      );
    }
  } catch (error) {
    yield put(ahActions.deliveredServiceFetched.error(error.message || error));
  }
}

function* manualDeliveriesFetch(state) {
  try {
    yield put(ahActions.manualDeliveriesFetched.pending);
    const response = yield call(api.manualDeliveriesFetch, state.payload);
    if (response) {
      yield put(
        ahActions.manualDeliveriesFetched.success(response.delivered_service)
      );
    }
  } catch (error) {
    yield put(ahActions.manualDeliveriesFetched.error(error.message || error));
  }
}

function* cosSettingCategoryFetch(state) {
  try {
    yield put(ahActions.getCategorySettingData.pending);
    const response = yield call(api.cosCategorySettingFetch, state.payload);
    if (response) {
      yield put(ahActions.getCategorySettingData.success(response));
    }
  } catch (error) {
    yield put(ahActions.getCategorySettingData.error(error.message || error));
  }
}

function* cosSettingContactFetch(state) {
  try {
    yield put(ahActions.getContactSettingData.pending);
    const response = yield call(api.cosContactSettingFetch, state.payload);
    if (response) {
      yield put(ahActions.getContactSettingData.success(response));
    }
  } catch (error) {
    yield put(ahActions.getContactSettingData.error(error.message || error));
  }
}

function* cosSettingPriorityFetch(state) {
  try {
    yield put(ahActions.getPrioritySettingData.pending);
    const response = yield call(api.cosPrioritySettingFetch, state.payload);
    if (response) {
      yield put(ahActions.getPrioritySettingData.success(response));
    }
  } catch (error) {
    yield put(ahActions.getPrioritySettingData.error(error.message || error));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ACTIONS.UPDATE_AH_CASE_NOTE_DETAIL_CALL, updateCaseNotesSaga),
    takeLatest(ACTIONS.GET_AH_CASE_NOTE_DETAIL_CALL, getCosCaseNoteDetailSaga),
    takeLatest(ACTIONS.GET_AH_FOLDER_LIST_FOR_HRM_CALL, getFolderListForHRMSaga),
    takeLatest(ACTIONS.CREATE_AH_NEWFOLDER_CALL, createNewFolderSaga),
    takeLatest(ACTIONS.UPDATE_AH_FOLDER_CALL, updateFolder),
    takeLatest(ACTIONS.REMOVE_AH_FOLDER_CALL, removeFolder),
    takeLatest(ACTIONS.REMOVE_AH_FILE_CALL, removeFile),
    takeLatest(ACTIONS.UPDATE_AH_PRIORITY_CALL, updatePriority),
    takeLatest(ACTIONS.UPDATE_AH_CONTACT_CALL, updateContact),
    takeLatest(ACTIONS.UPDATE_AH_CATEGORY_CALL, updateCategory),
    takeLatest(ACTIONS.GET_AH_CATOGERY_LIST_CALL, getCatogeryList),
    takeLatest(
      ACTIONS.GET_AH_REPORTING_TABLEDATA_CALL,
      getCosReportingFundingTableData
    ),
    takeLatest(ACTIONS.CREATE_AH_NEW_PERIORITY_CALL, createNewPeriority),
    takeLatest(ACTIONS.GET_AH_CONTACT_LIST_CALL, getContactList),
    takeLatest(ACTIONS.GET_AH_PERIORITY_LIST_CALL, getPeriorityList),
    takeLatest(
      ACTIONS.CHANGE_AH_INVOICE_STATUS_CALL,
      changeNDISClaimInvoiceActions
    ),

    takeLatest(ACTIONS.CREATE_AH_NEW_CONTACT_CALL, createNewContact),
    takeLatest(ACTIONS.CREATE_AH_NEW_CATEGORY_CALL, createNewCategory),
    takeLatest(ACTIONS.CHANGE_AH_NDIS_CLAIM_STATUS_CALL, changeNDISClaimActions),
    takeLatest(ACTIONS.GET_AH_CREATED_COS_INVOICES_CALL, getCreatedCosInvoices),
    takeLatest(
      ACTIONS.GET_AH_CLAIMED_CASE_NOTES_LIST_CALL,
      getClaimedCaseNotesList
    ),
    takeLatest(ACTIONS.GET_AH_NDIS_CLAIM_MODE_CALL, getNdisClaimMode),
    takeLatest(ACTIONS.UPDATE_AH_NDIS_CLAIM_MODE_CALL, updateNdisClaimMode),
    takeLatest(
      ACTIONS.GET_AH_CREATED_COS_INVOICES_RIVIEW_CALL,
      getCreatedCosInvoicesRviews
    ),
    takeLatest(ACTIONS.CREATE_AH_COS_INVOICE_CALL, createCosInvoice),
    takeLatest(ACTIONS.GET_AH_COS_INVOICES_CALL, getCoseInvoices),
    takeLatest(ACTIONS.GET_AH_CASE_NOTES_REVIEW_CALL, getCaseNotesReview),
    takeLatest(ACTIONS.GET_AH_CASE_NOTES_HISTROY_CALL, getCaseNotesHistoryList),
    takeLatest(
      ACTIONS.UPDATE_AH_CLIENT_TASKS_LIST_CALL,
      updateClientTasksListRequest
    ),
    takeLatest(
      ACTIONS.GET_AH_CASE_NOTES_LIST_FOR_CLAIM_CALL,
      getCaseNotesListForClaim
    ),
    takeLatest(
      ACTIONS.ADD_AH_CASE_NOTES_TO_CLAIM_LIST_CALL,
      addCaseNotesToClaimList
    ),
    takeLatest(ACTIONS.GET_AH_CASE_NOTES_CLIENT_CALL, getCaseNotesClients),
    takeLatest(ACTIONS.GET_AH_SINGLE_SUPPORT_TRACT_CALL, getSingleSupportTrack),
    takeLatest(ACTIONS.GET_AH_SUPPORT_TRACT_LIST_CALL, getSupportTrackList),
    takeLatest(ACTIONS.GET_AH_REPORT_DATA_CALL, getReportData),
    takeLatest(ACTIONS.DELETE_CLIENT_TASKS_CALL, deleteClientTasksListRequest),
    takeLatest(ACTIONS.GET_AH_CLIENT_TASKS_LIST_CALL, getClientTasksListRequest),
    takeLatest(ACTIONS.CREATE_AH_CLIENT_TASK_CALL, clientTaskCreate),
    takeLatest(ACTIONS.GET_AH_CASENOTES_LIST_CALL, getCaseNotesRequest),
    takeLatest(ACTIONS.AH_CASENOTES_CREATE_CALL, caseNotesCreate),
    takeLatest(ACTIONS.AH_PARTICIPANTS_PROFILE_CALL, getCosParticipantProfile),
    takeLatest(ACTIONS.AH_CATALOG_VERSIONS_CALL, getCatalogVersions),
    takeLatest(ACTIONS.AH_CATALOG_SERVICES_CALL, getAllCatalogServices),
    takeLatest(
      ACTIONS.STORE_AND_UPDATE_AH_FUNDING_SETUP_CALL,
      storeAndUpdateFundSetup
    ),
    takeEvery(
      ACTIONS.AH_CHECK_FUNDING_MANAGEMENT_IMPACT_CALL,
      checkFundingManagementImpact
    ),
    takeLatest(
      ACTIONS.AH_ALL_FUNDING_SETUP_PARTICIPANT_CALL,
      getFundingSetupParticipant
    ),
    takeLatest(ACTIONS.AH_DELETE_FUNDING_SETUP_CALL, deleteFundingSetupSaga),
    takeLatest(
      ACTIONS.AH_ALL_FUNDING_SETUP_PARTICIPANT_FOR_COS_CALL,
      getFundingSetupParticipantForCos
    ),

    takeLatest(
      ACTIONS.AH_CATALOG_SERVICES_SUB_CATEGORY_CALL,
      getAllCatalogServicesSubCategory
    ),
    takeLatest(ACTIONS.AH_SELCETED_FUNDING_SETUP_CALL, getSelectedFundingSetup),
    takeLatest(ACTIONS.GET_AH_DASHBOARD_DATA_CALL, getDashboardData),
    takeLatest(ACTIONS.AH_PLAN_CATAGORIES_CALL, getPlanCatagories),
    takeLatest(ACTIONS.CREATE_AH_PLAN_BUDGET_CALL, storePlanBudget),
    takeEvery(ACTIONS.AH_PLAN_BUDGET_LIST_CALL, planBudgetList),
    takeLatest(
      ACTIONS.AH_SERVICE_CATEGORY_PLAN_BUDGET_DELETE_CALL,
      serviceCategoryRemove
    ),
    takeEvery(ACTIONS.AH_PLAN_BUDGET_CAT_AND_SUB_CAT_CALL, planBudgetCatAndSubCat),
    takeEvery(
      ACTIONS.AH_SERVICE_CATEGORY_PLAN_BUDGET_STORE_CALL,
      storeServiceCategoryPlanBudget
    ),
    takeLatest(
      ACTIONS.AH_SERVICE_CATEGORY_PLAN_BUDGET_FETCH_CALL,
      fetchServiceCategoryPlanBudget
    ),
    takeEvery(ACTIONS.AH_EXTERNAL_SP_CREATE_CALL, externalSpCreate),
    takeLatest(ACTIONS.AH_EXTERNAL_SP_LIST_FETCH_CALL, getExternalSpRequest),

    takeEvery(ACTIONS.AH_FUNDING_NOTES_LIST_CALL, fundingNotesList),
    takeEvery(ACTIONS.CREATE_AH_FUNDING_NOTES_CALL, storeFundingNotes),
    // takeEvery(ACTIONS.FUNDING_NOTES_DELETE_CALL, fundingNotesRemove),
    takeLatest(
      ACTIONS.AH_SERVICE_SUPPORT_BUDGET_CREATE_CALL,
      serviceSupportCreate
    ),
    takeLatest(ACTIONS.AH_SERVICE_SUPPORT_BUDGET_FETCH_CALL, serviceSupportFetch),
    takeEvery(
      ACTIONS.AH_SERVICE_SUPPORT_FOR_DELIVERED_SERVICE_CALL,
      fetchServiceSupportsForDeliveredService
    ),
    takeLatest(ACTIONS.AH_PARTICIPANT_LIST_CALL, CosParticipantList),
    takeLatest(ACTIONS.AH_SUPPORT_COORDINATORS_CALL, supportCoordinator),
    takeLatest(ACTIONS.AH_DELIVERED_SERVICE_CREATE_CALL, deliveredServiceStore),
    takeLatest(
      ACTIONS.AH_MANUAL_DELIVERED_SERVICE_CREATE_CALL,
      manualDeliveredServiceStore
    ),
    takeLatest(ACTIONS.AH_DELIVERED_SERVICE_FETCH_CALL, deliveredServiceFetch),
    takeLatest(ACTIONS.AH_MANUAL_DELIVEREIES_FETCH_CALL, manualDeliveriesFetch),
    takeEvery(ACTIONS.AH_SETTING_CATEGORIES_CALL, cosSettingCategoryFetch),
    takeEvery(ACTIONS.AH_SETTING_CONTACT_CALL, cosSettingContactFetch),
    takeEvery(ACTIONS.AH_SETTING_PRIORITIES_CALL, cosSettingPriorityFetch),
  ]);
}
